import { Divider, Stack, Typography, Box, Button } from "@mui/material"
import { CalcItem } from "./CalcItem"
import ModalClub from "src/components/common/modal-club"
import { useState } from "react"

export function toPersian(v) {
  return Number(v).toLocaleString()
}
export function CalculatedItems({ data, priceIndex, refund, showClub = true }) {
  const [showClubModal, setShowClubModal] = useState(false)
  const value = { ...(data[priceIndex]?.detail[refund] || data[priceIndex]?.detail[0]) }
  Object.keys(value).forEach(k => {
    value[k] = toPersian(value[k]) + " "
  })
  const clubPlan = data[priceIndex]?.detail[0].title || ""

  const handleClub = () => {
    setShowClubModal(!showClubModal)
  }

  return (
    <div>
      {showClubModal && <ModalClub open={showClubModal} price={data[priceIndex]?.amount} plan={clubPlan} />}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1 }}>
        <Stack spacing={0} mb={1}>
          <Typography fontWeight={600}>
            مبلغ تسهیلات
          </Typography>
          <Typography textAlign='center' variant='h5' color='primary'>
            {toPersian(data[priceIndex]?.amount)} <Typography variant='span'>ریال </Typography>
          </Typography>
        </Stack>
        {clubPlan && showClub && (
          <Button
            color='primary'
            variant='outlined'
            size='medium'
            sx={{ borderRadius: "8px", cursor: "pointer" }}
            onClick={handleClub}
          >
            {clubPlan}
          </Button>
        )}
      </Box>
      <Stack spacing={1.2} mt={3}>
        <CalcItem label='سود' value={value.profitRate} postFix={"درصد"} />
        <CalcItem label='تعداد اقساط' value={value.installmentCount} postFix={"قسط"} />
        <CalcItem label='مبلغ قسط اول' value={value.firstInstallmentAmount} postFix={"ریال"} />
        <CalcItem label='مابقی اقساط' value={value.monthlyInstallmentAmount} postFix={"ریال"} />
        <CalcItem label='مجموع بازپرداخت اقساط' value={value.totalInstallmentAmount} postFix={"ریال"} />
        <Divider />
        {showClub && clubPlan && Number(value?.wageAmount) !== 0 && (
          <Typography textAlign='center' variant='h6' fontWeight={600} pt={1}>
            به منظور دریافت تسهیلات، عضویت در طرح {clubPlan} جت کلاب الزامی است.
          </Typography>
        )}
      </Stack>
    </div>
  )
}
